/* cørt. phone header — puts sign in and day/night into the phone menu (8 Oct 2026). */
(function(){
  var SUN='<svg class="cph-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.2M12 19.3v2.2M4.6 4.6l1.6 1.6M17.8 17.8l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.6 19.4l1.6-1.6M17.8 6.2l1.6-1.6"/></svg>';
  var MOON='<svg class="cph-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 14.2A8.5 8.5 0 1 1 9.8 3.5a6.8 6.8 0 0 0 10.7 10.7z"/></svg>';
  var h=document.documentElement;
  function modeText(){return h.getAttribute('data-cort-theme')==='light'?'night mode':'day mode'}
  function build(){
    var slot=document.querySelector('#Details-menu-drawer-container .menu-drawer__utility-links');
    if(!slot)return;
    var box=slot.querySelector('.cph-extras');
    var src=document.querySelector('header-actions .cort-signin-action');
    var tog=document.querySelector('header-actions .cort-mode-toggle');
    if(!box){
      box=document.createElement('div');box.className='cph-extras';
      if(src){var a=document.createElement('a');a.className='cph-row cph-signin';box.appendChild(a)}
      if(tog){
        var b=document.createElement('button');b.type='button';b.className='cph-row cph-mode';
        b.innerHTML='<span class="cph-mode-label"></span>'+SUN+MOON;
        b.addEventListener('click',function(){tog.click();sync()});
        box.appendChild(b);
      }
      slot.appendChild(box);
    }
    sync();
  }
  function sync(){
    var box=document.querySelector('.cph-extras');if(!box)return;
    var src=document.querySelector('header-actions .cort-signin-action'),a=box.querySelector('.cph-signin');
    if(src&&a){a.href=src.getAttribute('href');var l=src.querySelector('.cort-signin-action__label');a.textContent=(l?l.textContent:src.textContent).trim()||'sign in'}
    var m=box.querySelector('.cph-mode-label');if(m)m.textContent=modeText();
  }
  function init(){
    build();
    var d=document.getElementById('Details-menu-drawer-container');
    if(d)d.addEventListener('toggle',build);
    new MutationObserver(sync).observe(h,{attributes:true,attributeFilter:['data-cort-theme']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
